module.exports = __webpack_public_path__ + "static/assets/fba51ef9d035558a8d9692b9a415a158.png";